<template>
	<div class="permission-container">
		<div class="label-tip">
			<label>{{ $t(permission.label) }}</label>
			<Tippy
				arrow
				theme="large"
				:content="$t(permission.tooltip)"
				:options="{ animation: 'scale' }"
			>
				<CircleQuestionIcon regular class="help-icon"></CircleQuestionIcon>
			</Tippy>
		</div>
		<Dropdown
			global
			:options="options"
			v-model="selected"
			class="permission-dropdown"
			@change="$emit('change', $event)"
			:data-cy="permission.id"
		>
			<template #selected="{ option }">
				{{ $t(option.label) }}
			</template>

			<template v-slot="{ option }">
				<div class="option-label">{{ $t(option.label) }}</div>
				<div class="option-description" v-if="option.description">
					{{ $t(option.description) }}
				</div>
			</template>
		</Dropdown>
	</div>
</template>

<script>
import store, { getChat } from '@/store'
import { Dropdown, Tippy } from '@/components/common'
import { CircleQuestionIcon } from '@/icons'

const options = [
	{
		id: 'owner',
		label: 'groupsettings_permissions_owners',
	},

	{
		id: 'member',
		label: 'groupsettings_permissions_everyone',
	},
]

export default {
	components: {
		Dropdown,
		CircleQuestionIcon,
		Tippy,
	},

	props: {
		permission: Object,
		chat_id: Number,
	},

	data() {
		return {
			store,
			options,
			selected: getChat(this.chat_id)[this.permission.id] || 'member',
		}
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.permission-container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(50% - 8px);
	.label-tip {
		display: flex;
	}
	label {
		font-family: map-get($fonts, 500);
		color: var(--neutral-800);
		font-size: 14px;
		white-space: nowrap;
		margin-right: 5px;
	}
	.help-icon {
		font-size: 20px;
		color: var(--neutral-300);
		cursor: pointer;
		&:hover {
			color: var(--teal-300);
		}
	}
	.permission-dropdown {
		width: 165px;
	}
}
</style>
